import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
};

export const requireText: SxStyle = {
  color: (p) => p.palette.grey[500],
  fontSize: (p) => p.typography.caption.fontSize,
  textAlign: 'center',
};

export const requireWrapper: SxStyle = {
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
};
